import { render, staticRenderFns } from "./imgviewer.vue?vue&type=template&id=b0bebaaa&scoped=true&"
import script from "./imgviewer.vue?vue&type=script&lang=js&"
export * from "./imgviewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0bebaaa",
  null
  
)

export default component.exports